import { AdvertisementTranslations } from '@app/const/translations';
import { IAdvertisement } from './types';

export const ADVERTISEMENTS: IAdvertisement[] = [
  { // Кейс
    background: `/assets/img/login/login_advertisement_1.jpg`,
    backgroundPosition: 'bottom',
    title: AdvertisementTranslations.n1.title,
    main: AdvertisementTranslations.n1.main,
    url: 'https://infologistics.ru/keysy/kassovye-dokumenty',
  },
  { // Статья
    background: `/assets/img/login/login_advertisement_2.jpg`,
    backgroundPosition: 'bottom',
    title: AdvertisementTranslations.n2.title,
    main: AdvertisementTranslations.n2.main,
    url: 'https://infologistics.ru/blog/potokovoe-skanirovanie-dokumentov-chto-eto-i-kogda-nuzhno-biznesu',
  },
  { // Услуга
    background: `/assets/img/login/login_advertisement_3.jpg`,
    backgroundPosition: 'bottom',
    title: AdvertisementTranslations.n3.title,
    main: AdvertisementTranslations.n3.main,
    url: 'https://infologistics.ru/retail',
  },
  { // Новость
    background: `/assets/img/login/login_advertisement_4.png`,
    backgroundPosition: 'bottom',
    title: AdvertisementTranslations.n4.title,
    main: AdvertisementTranslations.n4.main,
    url: 'https://infologistics.ru/news/kak-mi-ispolzuem-rate-limiter-v-svoih-systemah',
  },
];

// Массив индексов с одинаковыми слайдами, которые не должны повторяться (может быть пустым)
export const ADVERTISEMENTS_SAME_SLIDE_IDX : number[] = [];
